import { Checkbox } from "@shared/checkbox";

import { type MetricConfig } from "../metric-category-builder";

export const DefaultMetricsSelector = <T extends MetricConfig>({
  metricOrderedVisibility,
  toggleMetricVisibility,
  changeAllVisibility,
}: {
  metricOrderedVisibility: T[];
  toggleMetricVisibility: (arg0: T) => void;
  changeAllVisibility: (allVisibility: boolean) => void;
}) => {
  return (
    <div
      className="p-5 overflow-y-scroll mx-8 mt-5"
      data-testid="metric-visibility-panel"
    >
      <h3 className="text-base font-semibold m-0 mb-3">Select metrics</h3>
      <div className="text-xxs mb-4 my-2">
        <button
          className="mr-4 hover:text-primary"
          onClick={() => changeAllVisibility(true)}
        >
          Select All
        </button>
        <button
          className="hover:text-primary"
          onClick={() => changeAllVisibility(false)}
        >
          Clear All
        </button>
      </div>
      <div className="grid grid-cols-2 text-xs font-light gap-0.5">
        {metricOrderedVisibility.map((metric) => (
          <div
            key={metric.name}
            className="flex-horizontal-center cursor-pointer mb-4"
            onClick={() => toggleMetricVisibility(metric)}
          >
            <Checkbox
              className="mr-3"
              onChange={() => {
                // Do nothing
              }}
              value={!!metric.visible}
            />
            <span>{metric.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
